import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'profileFilter'
})
export class ProfileFilterPipe implements PipeTransform {

    transform(value: any, args?: any): any {
        if (!value) return [];
        if (!args) return value;

        return value.filter(it => {
            return it.prev_state == args;
        });
    }
}


